import type { AvatarConfig } from "../types/websocket-messages";
import type { AvatarType } from "@/entities/avatar-scenario/const/config";

/**
 * 아바타 타입에 따른 기본 설정 반환
 * 새로운 스키마: avatar_id는 avatar 객체 내부에, agent_id는 data 레벨에 위치
 */
export const getAvatarAgentConfig = (avatarType: AvatarType): AvatarConfig => {
  switch (avatarType) {
    case 'glyx':
      return {
        avatar_name: "GLYX",
        avatar_id: "glyx-1",
        korean_voice_id: "DK_KR",
        english_voice_id: "DK_EN",
        chinese_voice_id: "DK_ZH",
        japanese_voice_id: "DK_JA",
        avatar_type: "GGLS_GLYX"
      };
    case 'nalnani':
      return {
        avatar_name: "NALNANI",
        avatar_id: "nalnani-1",
        korean_voice_id: "voxcpm2:hjh:ko",
        english_voice_id: "voxcpm2:hjh:en",
        chinese_voice_id: "voxcpm2:hjh:zh",
        japanese_voice_id: "voxcpm2:hjh:ja",
        avatar_type: "GGLS_NALNANI"
      };
    case 'kikiz':
      return {
        avatar_name: "KIKIZ",
        avatar_id: "kikiz-1",
        korean_voice_id: "KIKIZ_KR",
        english_voice_id: "KIKIZ_EN",
        chinese_voice_id: "KIKIZ_ZH",
        japanese_voice_id: "KIKIZ_JA",
        avatar_type: "GGLS_KIKIZ"
      };
    case 'bambam':
      return {
        avatar_name: "BAMBAM",
        avatar_id: "bambam-1",
        korean_voice_id: "BAMBAM_KR",
        english_voice_id: "BAMBAM_EN",
        avatar_type: "GGLS_BAMBAM"
      };
    case 'goesan':
      return {
        avatar_name: "JECHEON_GOESAN",
        avatar_id: "goesan-1",
        korean_voice_id: "voxcpm2:hjh:ko",
        english_voice_id: "voxcpm2:hjh:en",
        chinese_voice_id: "voxcpm2:hjh:zh",
        japanese_voice_id: "voxcpm2:hjh:ja",
        avatar_type: "GGLS_NALNANI"
      };
    case 'vroid':
      return {
        avatar_name: "VROID",
        avatar_id: "vroid-1",
        korean_voice_id: "VROID_KR",
        english_voice_id: "VROID_EN",
        chinese_voice_id: "VROID_ZH",
        japanese_voice_id: "VROID_JA",
        avatar_type: "GGLS_VROID"
      };
    // bobbi/taekwondo: avatar_name은 NALNANI 유지 필수 —
    // voice-server가 avatar_name으로 세션 등록(DEFAULT_AVATARS 게이트)과 TTS 프로바이더를 결정하므로
    // avatar identity는 유지하고, 자체 음성은 실제 HJH voice id로 지정한다
    case 'bobbi':
      return {
        avatar_name: "NALNANI",
        avatar_id: "bobbi-1",
        korean_voice_id: "voxcpm2:hjh:ko",
        english_voice_id: "voxcpm2:hjh:en",
        chinese_voice_id: "voxcpm2:hjh:zh",
        japanese_voice_id: "voxcpm2:hjh:ja",
        avatar_type: "GGLS_BOBBI"
      };
    case 'taekwondo':
      return {
        avatar_name: "NALNANI",
        avatar_id: "taekwondo-1",
        korean_voice_id: "voxcpm2:hjh:ko",
        english_voice_id: "voxcpm2:hjh:en",
        chinese_voice_id: "voxcpm2:hjh:zh",
        japanese_voice_id: "voxcpm2:hjh:ja",
        avatar_type: "GGLS_TAEKWONDO"
      };
    default:
      console.warn(`⚠️ 지원하지 않는 아바타 타입: ${avatarType}`);
      return {
        avatar_name: "NALNANI",
        avatar_id: "nalnani-default",
        korean_voice_id: "voxcpm2:hjh:ko",
        english_voice_id: "voxcpm2:hjh:en",
        chinese_voice_id: "voxcpm2:hjh:zh",
        japanese_voice_id: "voxcpm2:hjh:ja",
        avatar_type: "GGLS_NALNANI"
      };
  }
};

